import React, { useEffect, useState, useContext } from "react";
import {useLocation,  useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import { LocationContext } from "../context/LocationContext";

export default function RxCheckoutPage() {
  const { rxId } = useParams();
  const navigate = useNavigate();

  const { address: autoAddress, lat, lng } = useContext(LocationContext);

  const [summary, setSummary] = useState(null);
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
const location = useLocation();


const requestIdFromNotification = location.state?.requestId;
console.log("rx-checkout received requestId:", requestIdFromNotification);
  // Load user phone
  useEffect(() => {
    axiosInstance.get("/user-info/")
      .then(res => setPhone(res.data.phone || ""))
      .catch(() => {});
  }, []);

  // Auto address
  useEffect(() => {
    if (autoAddress) setAddress(autoAddress);
  }, [autoAddress]);

  // Preview (price + delivery)
  useEffect(() => {
    if (!lat || !lng || !rxId) return;

    axiosInstance.post("/rx-checkout/preview/", {
      	
      rx_id: rxId,
    })
    .then(res => setSummary(res.data))
    .catch(err => {
      console.error(err.response?.data);
      alert("Unable to calculate price");
    });
  }, [lat, lng, rxId]);

  // Place order
  const handlePay = async () => {
    if (!address || address.length < 5) {
      alert("Enter valid address");
      return;
    }
    if (!phone || phone.length < 10) {
      alert("Enter valid phone number");
      return;
    }
    if (!termsAccepted) {
      alert("Please accept Terms & Conditions");
      return;
    }

    try {
      setLoading(true);

      const res = await axiosInstance.post(`/rx-checkout/${rxId}/`, {
        address: address,
        phone: phone,
        customer_lat: lat,
        customer_lng: lng,
        delivery_charge: summary.delivery_charge, // from preview
        terms_accepted: termsAccepted,
      });

      navigate(`/payment/${res.data.internal_order_id}`,{
        state: { requestId: requestIdFromNotification }
});
    } catch (err) {
      alert(err.response?.data?.error || "Checkout failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 800, margin: "auto", padding: 20 }}>
      <h1>Prescription Checkout</h1>

      {!summary && <p>Calculating price...</p>}

      {summary && (
        <>

    {/* ORIGINAL */}
    <p>
      Original Price:{" "}
      <span style={{ textDecoration: "line-through", color: "#777" }}>
        ₹{Number(summary.original_price).toFixed(2)}
      </span>
    </p>

{summary?.bill_image && (
  <div style={{ marginTop: 20 }}>

    <h4>Uploaded Bill / Receipt</h4>

    {/* 🔍 IMAGE PREVIEW */}
    <div style={{ position: "relative", display: "inline-block" }}>
      <img
        src={summary.bill_image}
        alt="Bill"
        onClick={() => window.open(summary.bill_image, "_blank")}
        style={{
          width: "100%",
          maxWidth: 350,
          borderRadius: 8,
          border: "1px solid #ddd",
          cursor: "zoom-in",
          transition: "0.3s",
        }}
      />

      {/* ⬇ DOWNLOAD BUTTON */}
      <a
        href={summary.bill_image}
        download
        style={{
          position: "absolute",
          bottom: 10,
          right: 10,
          background: "#000",
          color: "#fff",
          padding: "6px 10px",
          fontSize: 12,
          borderRadius: 5,
          textDecoration: "none",
          opacity: 0.8
        }}
      >
        ⬇ Download
      </a>
    </div>

    {/* 💡 TIP */}
    <p style={{ fontSize: 12, color: "#777", marginTop: 8 }}>
      💡 Tip: Click image to view full size or download for clarity
    </p>

  </div>
)}

    {/* DISCOUNT */}
    {summary.discount_amount > 0 && (
      <p style={{ color: "green" }}>
        Discount ({summary.discount_percent}%): -₹
        {Number(summary.discount_amount).toFixed(2)}
      </p>
    )}

    {/* AFTER DISCOUNT */}
    <p>
      Price after Discount:{" "}
      <strong>
        ₹{Number(summary.price_after_discount).toFixed(2)}
      </strong>
    </p>

    {/* DELIVERY */}
    <p>
      Delivery Charge: ₹
      {Number(summary.delivery_charge || 0).toFixed(2)}
    </p>

    <p style={{ fontSize: 13, color: "#666" }}>
      Distance: {Number(summary.delivery_distance_km || 0).toFixed(1)} km
    </p>

    <hr />

    {/* FINAL */}
    <h2>
      Total Payable: ₹
      {Number(summary.payable_amount || 0).toFixed(2)}
    </h2>

    {summary.discount_amount > 0 && (
      <p style={{ color: "green", fontSize: 14 }}>
        🎉 You saved ₹{Number(summary.discount_amount).toFixed(2)}
      </p>
    )}





        </>
      )}

      <hr />



      <div style={{ marginTop: 15 }}>
        <label>
          <input
            type="checkbox"
            checked={termsAccepted}
            onChange={e => setTermsAccepted(e.target.checked)}
          />{" "}
          I agree to Terms & Conditions
        </label>
      </div>

<button
  onClick={handlePay}
  disabled={loading || !termsAccepted}
  style={{
    width: "100%",
    marginTop: 20,
    padding: 14,
    background: !termsAccepted ? "#ccc" : "#0a8f08", // 🔥 CHANGE
    color: "#fff",
    border: "none",
    borderRadius: 6,
    cursor: !termsAccepted ? "not-allowed" : "pointer",
    opacity: !termsAccepted ? 0.7 : 1, // 🔥 FADE EFFECT
    transition: "0.2s"
  }}
>
  {loading ? "Processing..." : "Pay Online"}
</button>
    </div>
  );
}
